/* Collection size guide toggle. Kept separate from the size finder: this one answers
   "how big is a 9x12" for someone still browsing, the finder answers "does THIS rug fit
   my room" once she is on a product. */
(function () {
  function boot() {
    document.querySelectorAll('.bm-sg').forEach(function (root) {
      if (root.dataset.bmReady) return;
      root.dataset.bmReady = '1';
      var t = root.querySelector('.bm-sg-trigger'), p = root.querySelector('.bm-sg-panel');
      if (!t || !p) return;
      t.addEventListener('click', function () {
        var on = p.classList.toggle('is-on');
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
